import React from "react";
import { Field } from "formik";
import styles from "./Input.module.scss";
import _ from "lodash";

import cx from "classnames";
const View = ({
  name,
  validate,
  fast,
  placeholder,
  required,
  onChange,
  onBlur,
  theme = "light",
  type = "text",
}: any) => {
  const ref: any = React.useRef({});
  const onChangeHandle = (event: any) => {
    const value = _.get(event, "target.value");

    ref.current.form && ref.current.form.setFieldValue(name, value);
    onChange && onChange(value);
  };
  const onBlurHandle = (e: any) => {
    ref.current.form && ref.current.form.setFieldTouched(name);
    onBlur && onBlur(e);
  };
  return (
    <Field name={name} validate={validate} fast={fast}>
      {({ field: { value }, form, meta }: any) => {
        ref.current.form = form;
        return (
          <div
            className={cx(styles.group, {
              [styles.valid]: !!value,
            })}
          >
            <input
              type={type}
              value={value}
              onChange={onChangeHandle}
              onBlur={onBlurHandle}
              aria-label={name}
              title=""
              className={cx({ [styles.dark]: theme === "dark" })}
            />
            <span className={styles.highlight} />
            <span className={styles.bar} />
            <label className={cx({ [styles.dark]: theme === "dark" })}>
              {placeholder}
              {required && <span className={styles.required}>*</span>}
            </label>
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        );
      }}
    </Field>
  );
};
export default View;
